import * as R from 'ramda'
import moment from 'moment'
import { parsePeriod } from 'utils/stuff'

export default (leases, listings, properties, startMarketDateByPropertyID, period) => {
	let parsedPeriod = period == 'projected' ? parsePeriod('YTM') : parsePeriod(period)

	let leasesByPropertyID = R.pipe(
		R.values
	  , R.map(x => {if(x.parentID) x.propertyID = leases[x.parentID] && leases[x.parentID].propertyID; return x} )
	  , R.groupBy(R.prop('propertyID'))
	  , R.map(docs => R.pipe(R.sortBy(x => moment(x.dateFrom)), R.reverse)(docs))
	)(leases)
	let listingsByPropertyID = R.pipe(
		R.values
	  , R.groupBy(R.prop('propertyID'))
	  , R.map(docs => R.pipe(R.sortBy(x => moment(x.dateFrom)), R.reverse)(docs))
	)(listings)

	let res = R.map(property => {
		let startPeriod = moment(parsedPeriod.from) > moment(startMarketDateByPropertyID[property._id]) ? parsedPeriod.from : startMarketDateByPropertyID[property._id]
		let intervals = []
		let currIntervalEnd = moment(startPeriod).endOf('month')
		let currIntervalStart = moment(startPeriod)

		while(currIntervalEnd <= moment(parsedPeriod.to).endOf('day')){
			intervals.push({firstDay: currIntervalStart.format('YYYY-MM-DD'), lastDay:currIntervalEnd.format('YYYY-MM-DD')})
			currIntervalEnd.add(1, 'month').endOf('month')
			currIntervalStart.add(1, 'month').startOf('month')
		}
		let potentialRent = 0
		for(let i = 0; i < intervals.length; i++){
			let interval = intervals[i]
			let fullDays = moment(interval.lastDay).diff(moment(interval.firstDay), 'days') + 1
			let currMonth = moment(startPeriod).add(i, 'month')
			let currMonthStart = currMonth.startOf('month')
			let currMonthEnd = currMonth.endOf('month')
			let activeLease = R.find(lease => moment(lease.date) <= currMonthStart && moment(lease.breakDate || lease.dateTill) >= currMonthStart)(leasesByPropertyID[property._id] || [])
			let futureLease = R.find(lease => moment(lease.date) > currMonthStart && moment(lease.date) <= moment(parsedPeriod.to))(leasesByPropertyID[property._id] || [])
			let lastListing = listingsByPropertyID[property._id] && listingsByPropertyID[property._id][0]
			let currRent = activeLease ? activeLease.rent : futureLease ? futureLease.rent : lastListing? lastListing.rent : 1000
			potentialRent += currRent / currMonth.daysInMonth() * fullDays
		}

		return potentialRent
	})(properties)

	res.total = R.pipe(R.values, R.reduce((acc, next) => acc + next, 0))(res)
	if(period == 'projected') {
		let projectedRent = potentialRentProjected(leases, listings, properties, startMarketDateByPropertyID, period)
		res = R.mergeWith(R.add, res, projectedRent)
	}
	return res
}

export let potentialRentProjected = (leases, listings, properties, startMarketDateByPropertyID, period) => {
	let parsedPeriod = parsePeriod(period)

	let leasesByPropertyID = R.pipe(
		R.values
	  , R.map(x => {if(x.parentID) x.propertyID = leases[x.parentID] && leases[x.parentID].propertyID; return x} )
	  , R.groupBy(R.prop('propertyID'))
	  , R.map(docs => R.pipe(R.sortBy(x => moment(x.dateFrom)), R.reverse)(docs))
	)(leases)
	let listingsByPropertyID = R.pipe(
		R.values
	  , R.groupBy(R.prop('propertyID'))
	  , R.map(docs => R.pipe(R.sortBy(x => moment(x.dateFrom)), R.reverse)(docs))
	)(listings)

	let res = R.map(property => {
		let intervals = []
		let currIntervalEnd = moment(parsedPeriod.from).endOf('month')
		let currIntervalStart = moment(parsedPeriod.from)
		while(currIntervalEnd <= moment(parsedPeriod.to).endOf('day')){
			intervals.push({firstDay: currIntervalStart.format('YYYY-MM-DD'), lastDay:currIntervalEnd.format('YYYY-MM-DD')})
			currIntervalEnd.add(1, 'month').endOf('month')
			currIntervalStart.add(1, 'month').startOf('month')
		}

		let potentialRent = 0
		for(let i = 0; i < intervals.length; i++){
			let interval = intervals[i]
			let fullDays = moment(interval.lastDay).diff(moment(interval.firstDay), 'days') + 1
			let currMonth = moment(period.from).add(i, 'month')
			let currMonthStart = currMonth.startOf('month')
			let currMonthEnd = currMonth.endOf('month')
			let activeLease = R.find(lease => moment(lease.date) <= currMonthStart && moment(lease.breakDate || lease.dateTill) >= currMonthStart)(leasesByPropertyID[property._id] || [])
			let futureLease = R.find(lease => moment(lease.date) > currMonthStart && moment(lease.date) <= moment(parsedPeriod.to))(leasesByPropertyID[property._id] || [])
			let lastListing = listingsByPropertyID[property._id] && listingsByPropertyID[property._id][0]
			let currRent = activeLease ? activeLease.rent : futureLease ? futureLease.rent : lastListing? lastListing.rent : 1000
			potentialRent += currRent / currMonth.daysInMonth() * fullDays
		}
		return potentialRent
	})(properties)
	res.total = R.pipe(R.values, R.reduce((acc, next) => acc + next, 0))(res)
	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/potentialRent.js